/**
 * @fileoverview POST handler for the "/:app_group_id/braze_mcp/call_tool" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postAppGroupIdBrazeMcpCallToolCacheKeys } from "./constants";
import type {
  PostAppGroupIdBrazeMcpCallToolErrors,
  PostAppGroupIdBrazeMcpCallToolProps,
  PostAppGroupIdBrazeMcpCallToolResult,
} from "./types";

export const postAppGroupIdBrazeMcpCallTool = reactQueryMutationAdapter(
  postAppGroupIdBrazeMcpCallToolCacheKeys,
  createMutationFetcherFunctionWithShadowError<PostAppGroupIdBrazeMcpCallToolErrors>()(
    (props: PostAppGroupIdBrazeMcpCallToolProps): Promise<PostAppGroupIdBrazeMcpCallToolResult> => {
      return fetch(
        `/${props.appGroupId}/braze_mcp/call_tool`,
        "POST",
        {
          tool_name: props.toolName,
          arguments: props.arguments,
        },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
